import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { UserState } from '@api/models/enums/UserState';
import { UserRole } from '@api/models/enums/UserRole';
import { supplierEmployeeService } from '@api/services/services';

export interface SupplierEmployeeListFilter extends ListFilter {
  state?: UserState[];
  role?: UserRole;
}

export type SupplierEmployeeListState = ListType<SupplierEmployeeDto, SupplierEmployeeListFilter>;

const initialState: SupplierEmployeeListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    state: [UserState.Active, UserState.Invited, UserState.Requested],
  },
};

export const supplierEmployeeListSlice = listSlice({
  name: 'supplierEmployeeList',
  initialState,
});

export const selectSupplierEmployeeList = (state: RootState) => state.supplierEmployeeList;
export const supplierEmployeeListActions = supplierEmployeeListSlice.actions;

export const getSupplierEmployeeList = (supplierId: string, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectSupplierEmployeeList(storeState);

  const handleGetData = (size: number) => {
    return supplierEmployeeService.query(
      {
        supplierId: supplierId,
        q: data.query.q,
        state: data.query.state,
        role: data.query.role,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: supplierEmployeeListActions,
    getData: handleGetData,
  });
};
